/*global window, document, location, navigator, screen, app */

// 1. Debug or minified
const search = location.search;
const isDebug = search.indexOf('debug') !== -1;

// 2. Desktop or mobile
const ua = navigator.userAgent;
const isMobile = false;

// 3. Are we in the app?
const isApp =
    typeof app === 'object' ||
    ua.indexOf(' FastMail/') > -1 ||
    /[?&]isApp=1/.test(search);

// 4. Do we have any info on sessions and which user to load?
let sessions = null;
try {
    sessions = JSON.parse(
        document.getElementById('bootstrap-page').getAttribute('data-sessions'),
    );
} catch (error) {}

const user = /[?&]u=(\w+)/.exec(location.search);

// 5. Build our config file
const origin =
    (window.app &&
        app.baseDomain &&
        // At the time of writing (2018-08-24) the iOS bootstrap includes a trailing
        // slash, but the Android one doesn’t. This inconsistency is a bug.
        app.baseDomain.replace(/\/$/, '')) ||
    location.protocol + '//' + location.host;

const FM = {
    isApp,
    isMobile,
    isDebug,

    version: document.documentElement.getAttribute('data-version'),

    origin,
    pathToDist: '/static/helpui',

    sessions,
    userId: user ? user[1] : '',

    doAction(type, args) {
        (FM._initActions || (FM._initActions = [])).push([type, args]);
    },
};

// ---

export { FM };
